var path = '/configuration/configuration.tpl.html';
var html = "<div class=\"content configurationContainer\" ui-view=\"view\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;